import React from "react";
import { useSelector } from "react-redux";
import { roleCheck } from "utils/index";
import { VIRTUAL_DRAFTING, VIRTUAL_DRAFTING_MANAGER } from "../../../../../../../utils/constants";
import { getBaseUrl, getCurrentRole, getCurrentUser } from "../../../../../reducers";
import VirtualDraftingStage from "./VirtualDraftingStage";
import SelectVrDraftsman from "../../dropdowns/SelectVrDraftsman";

const VirtualDrafting = ({
  jobService, reloadData, forAdditionalWork
}) => {
  const {
    id,
    attributes: {
      state, primaryVrDraftsmmanName
    }
  } = jobService
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentRole = useSelector(getCurrentRole)
  const currentTeamRole = currentUser.attributes.current_team_role
  const isVrDraftingTeam = roleCheck(systemRole, currentRole, VIRTUAL_DRAFTING)
  const isVrDraftingManager = roleCheck(systemRole, currentTeamRole, VIRTUAL_DRAFTING_MANAGER)

  return (
    <li className="activity timeline-activity" key="virtual-drafting">
      <div className="circle circle-outline" />
      <div className="d-flex justify-content-between">
        <div className={`activity-status ${!isVrDraftingTeam ? "mb-3" : null}`}>
          <strong>Virtual Drafting</strong>
          { primaryVrDraftsmmanName && (
            <strong className="ml-2">{`(${primaryVrDraftsmmanName})`}</strong>
          )}
        </div>

        <SelectVrDraftsman
          jobService={jobService}
          reloadData={reloadData}
          readOnly={!isVrDraftingManager} />
      </div>
      <VirtualDraftingStage
        forAdditionalWork={forAdditionalWork}
        jobService={jobService}
        reloadData={reloadData} />
    </li>
  )
}

export default VirtualDrafting